<template>
    <!-- FOF详情列表 -->
    <div>
        <div class="row-four">FOF详情列表</div>
        <el-table class="table-two mt30" :data="comTable" border>
            <el-table-column property="productName" label="产品名称" width="230">
                <template slot-scope="scope">
                    <a class="line_one mainColor" :href="'#/product?code='+scope.row.innerCode" :title="scope.row.productName" target="_blank">{{scope.row.productName}}</a>
                </template>
            </el-table-column>
            <el-table-column property="createDate" label="创建日期" width="100"></el-table-column>
            <el-table-column property="dealDate" label="净值日期" width="100"></el-table-column>
            <el-table-column property="unitEquity" label="单位净值"></el-table-column>
            <el-table-column property="monthYield" label="月收益率"></el-table-column>
            <el-table-column property="yearYield" label="年收益率"></el-table-column>
            <el-table-column property="totalYield" label="累计收益率"></el-table-column>
            <el-table-column label="操作" width="300">
                <template slot-scope="scope">
                    <el-upload style="display:inline-block;" action :show-file-list="false" :on-progress="(event, file, fileList) => {importChange(event, file, fileList, scope.row)}">
                        <span class="btn-normal">估值表导入</span>
                    </el-upload>
                    <span class="btn-normal" @click="report(scope.row,'周报')">周报</span>
                    <span class="btn-normal" @click="monthEdit(scope.row)">月报编辑</span>
                    <span class="btn-normal" @click="report(scope.row,'月报')">月报</span>
                </template>
            </el-table-column>
        </el-table>
        <!-- 弹框 -->
        <el-dialog class="strategy-dialog" :visible.sync="dialogVisible" width="520px" :show-close="false">
            <div class="strategy-dialog-tit">策略修改</div>
            <div class="strategy-dialog-con">
                <div class="strategy-dialog-con-li" v-for="(item,i) in indexArr" :key="i+'bd'">
                    <span class="label">{{item.value}}</span>
                    <el-select v-model="item.strategy">
                        <el-option :label="item" :value="item" v-for="(item,i) in strategyArr" :key="i+'c'"></el-option>
                    </el-select>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="btn" style="background:#61A1BF;" @click="jump('cancel')">取 消</el-button>
                <el-button class="btn" @click="jump('submit')">确认</el-button>
            </span>
        </el-dialog>
        <!-- 月报编辑 -->
        <el-dialog title="月报编辑" class="dialog-normal" :visible.sync="dialogMonth" @close="views = []">
            <div class="clearfix" style="padding: 48px 125px 0;">
                <el-form class="form-info" :model="monthForm" :inline="true" label-position="right">
                    <el-form-item label="日期" prop="date">
                        <el-date-picker type="month" class="date-picker-one" style="width: 115px;" v-model="monthForm.date" :editable="false" placeholder="选择日期" :clearable="false" value-format="yyyy-MM" @change="dateChange"></el-date-picker>
                    </el-form-item>
                </el-form>
                <el-transfer class="transfer-normal" 
                    v-model="views" 
                    :props="{key: 'id',label: 'title'}"
                    :data="transferData"
                    :titles="['当期宏观分析列表：', '已选宏观分析：']">
                </el-transfer>
                <el-button type="normal" class="mt30 fr" @click="preserve">保存</el-button>
            </div>
        </el-dialog>
        <!-- 修改份额变动标列表 -->
        <el-dialog class="strategy-dialog" :visible.sync="valuationDialogVisible" width="520px" :show-close="false">
            <div class="strategy-dialog-tit">申赎金额</div>
            <div class="strategy-dialog-con">
                <div class="strategy-dialog-con-li" v-for="(item,i) in fundList" :key="i+'gz'">
                    <span class="label" style="min-width: 300px;">{{item.value}}</span>
                    <el-input v-model="item.money"></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <span></span>
                <el-button class="btn" @click="valuationSubmit">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                comTable: [],
                ProductCode: '',
                dealDate: '',
                weekType: '',
                dialogVisible: false,
                indexArr: [],
                strategyArr: ['未分类','流动性','债券策略','套利策略','股票多头','CTA策略','市场中性'],
                // 月报编辑
                dialogMonth: false,
                monthForm: {date: ''},
                transferData: [],
                views: [],//1, 4
                viewCode: '',
                valuationDialogVisible: false,
                fundList: [],
                fundActive: {
                    fundCode: '',
                    fundDate: '',
                },
            }
        },
        mounted() {
            this.monthForm.date = this.$commonJs.timeFormat(new Date(),'yyyy-mm')
            this.getProductList()
        },
        methods: {
            report(row,type) {
                let vm = this
                vm.weekType = type
                vm.ProductCode = row.productCode
                vm.dealDate = row.dealDate
                vm.getNullSecurityType()
            },
            getProductList() {
                let vm = this
                vm.$http.post(vm.$apiPath.GetProductList,{
                    Page: 1,
                    PageNum: 20
                }).then(res => {
                    // console.log(res);
                    vm.comTable = res.data.data.dataList
                }).catch(err => {})
            },
            getNullSecurityType() {
                let vm = this
                vm.$http.post(vm.$apiPath.GetNullSecurityType,{
                    ProductCode: vm.ProductCode
                }).then(res => {
                    // console.log(res);
                    if(res.data.code == 200) {
                        let xdata = res.data.data.dataList
                        if(xdata.length > 0) {
                            xdata.forEach(item => {
                                item.strategy = '未分类'
                            })
                            vm.indexArr = xdata
                            vm.dialogVisible = true
                        } else {
                            vm.getHref()
                        }
                    }
                }).catch(err => {})
            },
            jump(type) {
                let vm = this
                let codeArr = []
                let strategyArr = [];
                vm.indexArr.forEach(item => {
                    codeArr.push(item.name)
                    strategyArr.push(item.strategy)
                })
                // console.log(codeArr,strategyArr);
                if(type == 'submit') {
                    vm.$http.post(vm.$apiPath.SetNullSecurityType,{
                        ProductCode: vm.ProductCode,
                        InnerCodes: codeArr,
                        Types: strategyArr,
                    }).then(res => {
                        // console.log(res);
                    }).catch(err => {})
                }
                vm.getHref()
                vm.dialogVisible = false
            },
            getHref() {
                let vm = this
                const { href } = this.$router.resolve({
                    name: 'weekly',
                    query: {
                        weeklyType:vm.weekType=='周报'? '0' : '1',
                        weeklyCode:vm.ProductCode,
                        dealDate:vm.dealDate,
                    },
                })
                window.open(href, '_blank')
            },
            importChange(event, file, fileList, row) {
                this.$commonJs.getBase64(file.raw).then(result => {
                    this.addedProductExcel(result,file.name,row)
                });
                return false
            },
            addedProductExcel(result,name,row) {
                let vm = this
                vm.$http.post(vm.$apiPath.AddedProductExcel,{
                    ProductCode: row.productCode,
                    FileName: name,    //文件名称
                    FileFlow: result,  //文件Base64字符串
                    FileType: row.fileType,    //文件类型，列表接口里获取的值
                }).then(res => {
                    // console.log(res);
                    if(res.data.code == 200 && res.data.data.note) {
                        vm.getProductSecurityChange(row.productCode,res.data.data.note)
                    } else {
                        vm.$message.error('估值表导入失败')
                    }
                }).catch(err => {})
            },
            // 月报编辑
            monthEdit(row) {
                this.dialogMonth = true
                this.viewCode = row.productCode
                this.getViewListByDate()
            },
            getViewListByDate() {
                let vm = this
                vm.$http.post(vm.$apiPath.GetViewListByDate,{
                    DealDate: vm.monthForm.date,
                    ProductCode: vm.viewCode,//组合编号
                    UserCode: vm.$commonJs.getCookie('userCode'), //用户编号
                }).then(res => {
                    // console.log(res);
                    if(res.data.code == 200) {
                        let xdata = res.data.data.dataList
                        vm.transferData = xdata[0]
                        if(xdata[1].length > 0) {
                            xdata[1].forEach(item => {
                                vm.views.push(item.id)
                            })
                        } 
                    }
                }).catch(err => {})
            },
            // 保存
            preserve() {
                let vm = this
                vm.$http.post(vm.$apiPath.SetMonthlyView,{
                    DealDate: vm.monthForm.date,
                    ProductCode: vm.viewCode,
                    UserCode: vm.$commonJs.getCookie('userCode'), //用户编号
                    IDs: vm.views,
                }).then(res => {
                    console.log(vm.views);
                    if(res.data.code == 200 && res.data.data.note) {
                        this.$message.success('月报编辑成功')
                    } else {
                        this.$message.error('月报编辑成功')
                    }
                    this.dialogMonth = false
                }).catch(err => {})
            },
            dateChange() {
                this.views = []
                this.getViewListByDate()
            },
            // 修改份额变动标列表
            getProductSecurityChange(code,date) {
                let vm = this
                vm.fundActive = {
                    fundCode: code,
                    fundDate: date,
                },
                vm.$http.post(vm.$apiPath.GetProductSecurityChange,{
                    ProductCode: code,
                    DealDate: date,
                }).then(res => {
                    // console.log(res);
                    if(res.data.code == 200 && res.data.data.dataList.length > 0) {
                        let list = res.data.data.dataList
                        list.forEach(item => {
                            item.money = ''
                        })
                        vm.fundList = list
                        vm.valuationDialogVisible = true
                    }
                }).catch(err => {})
            },
            valuationSubmit() {
                let vm = this
                let list = []
                vm.fundList.forEach(item => {
                    list.push({
                        Name: item.name,
                        Value: item.money-0,
                    })
                })
                vm.$http.post(vm.$apiPath.SetProductSecurityChange,{
                    ProductCode: vm.fundActive.fundCode,
                    DealDate: vm.fundActive.fundDate,
                    Securitys: list
                }).then(res => {
                    // console.log('submit',res);
                    if(res.data.code == 200 && res.data.data.note) {
                        vm.$message.success('修改份额变动提交成功')
                    } else {
                        vm.$message.error('修改份额变动提交失败')
                    }
                    vm.valuationDialogVisible = false
                }).catch(err => {})
            }
        }
    }
</script>

<style lang="less" scoped>
/* 添加对话框 */ 
.strategy-dialog {
    .label {min-width: 200px;display: inline-block;}
    &-con {
        height: 300px;overflow-y: auto;margin: 30px 10px 0;
        &-li {margin-bottom: 10px;display: flex;justify-content: space-between;align-items: center;}
    }
    /deep/.el-dialog {border-radius: 10px;}
    /deep/.el-dialog__header {padding: 0;}
    &-tit {font-size: 18px;color: @color3;}
    /deep/.el-input--suffix .el-input__inner {width: 150px;height: 28px;border: 1px solid @mainColor;border-radius: 18px;color: @mainColor;text-align: center;}
    /deep/.el-input__suffix .el-input__suffix-inner .el-select__caret:before {
        content: "";
        background: url(../../assets/images/select_down_b.png) center center no-repeat;
        position: absolute;
        width: 100%;
        height: 100%;
        transform: rotate(180deg);
        top: 0%;
        right: 0%;
    }
    /deep/.el-input .el-input__inner {
        width: 120px;height: 28px;border: 1px solid @borderColor;
    }
    /deep/.el-dialog__footer {
        padding: 0 55px 44px;
        .dialog-footer {display: flex;justify-content: space-between;}
    }
    .btn {width: 128px;height: 36px;background: @mainColor;border-radius: 18px;color: @whiteColor;padding: 0;}
}
.dialog-normal .form-info .el-form-item .el-input /deep/.el-input__inner {width: 158px;}
</style>